export const formatCodeFromName = (name: string) => (name ? name?.replaceAll(/[^a-zA-Z0-9]/g, '_')?.toLowerCase() : '')
export const formatCodeFromNameAndSanitize = (name: string) => {
  let toCode = formatCodeFromName(name.trim())
  while (toCode && toCode.endsWith('_')) toCode = toCode.slice(0, -1)
  return toCode
}
